import {
  MandateFiltersForPrincipal,
  MandateSelectionFilter,
} from './Mandate.types';
import { ReportPersistence } from './PowerBi.types';
import { FilterByPrincipal } from './Principal.types';
import { Role } from './Role.types';

export enum UserType {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
  GLOBAL = 'global',
}

export enum Currency {
  EUR = 'EUR',
  USD = 'USD',
}

export type UserData = {
  reportPersistence?: ReportPersistence;
  roles: { [key: string]: Role };
  bigMenuIsOpenToggle: boolean;
  lastNewFileCheck: string;
  global_user?: GlobalUser;
  userId: string;
  email?: string;
  signedIn?: boolean;
  name?: string;
  mapFilters?: FilterByPrincipal;
  creationTime?: string;
  mandateFilters?: {
    [key: string]: MandateFiltersForPrincipal;
  };
  currency: Currency;
  assignedMandates?: { [key: string]: number };
  acceptedTermsOfUse?: Date;
};

export type GlobalUser = {
  role: Role;
  principalRoles?: Record<string, Role>;
};

export type DeleteUsersRequest = {
  userIdsToDelete: string[];
  currentPrincipalId: string;
};

export type ViewUsersRequest = {
  currentPrincipal?: string;
  userIdToView?: string;
  allInternalUsers?: boolean;
};

export type EditUserRequest = {
  currentPrincipal: string;
  userIdToEdit: string;
  editedUserData: Partial<UserData>;
};

export type DeleteUsersResponse =
  | {
      success: boolean;
      result: {
        deleted: string[];
        notDelete: string[];
      };
    }
  | { code: string };

export type BaseUserType = {
  email: string;
  firstName: string;
  lastName: string;
};

export type AdUserType = {
  name: string;
  email: string;
  guid: string;
};

// This is a helper object that encapsulates wraps the firebase [user] document and encapsulates the [global_user] document
export type PortalUser = UserData & {
  global?: GlobalUser;
  userType?: UserType;
};

export type NewUserDetails = {
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
  role: string | undefined;
  mandateFilters: MandateSelectionFilter;
};

export enum GlobalUserTableColumn {
  NAME = 'name',
  EDIT = 'editRights',
}

export type GlobalUserPrincipalRole = {
  [principalName: string]: Role;
};
